import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

import { throwSlackMutationError } from './throw-slack-mutation-error';

type Response = { data: { authorizeUrl: string } };

export const useSlackAuthorize = createMutation<Response, void, AxiosError>({
  mutationFn: async () =>
    client
      .post('v2/internal/partners/organizations/integrations/slack/authorize')
      .then((response) => response.data)
      .catch((err: any) => {
        throwSlackMutationError(err, 'Could not connect to Slack');
      }),
});
